module.exports = __webpack_public_path__ + "static/media/16.ed557275.jpg";